import { HttpBackend, HttpClient } from '@angular/common/http'
import { environment } from 'src/environments/environment'
import { Injectable } from '@angular/core'
import { shareReplay } from 'rxjs/operators'
import { ActivatedRoute } from '@angular/router'
import { of } from 'rxjs'

import { INTEGRATION_WORD_CONSTANTS } from '../shared/constants/integration-word-constant'

@Injectable({
  providedIn: 'root',
})
/**
 * It will replace the S3 bucket variable according to the environment subdomains "test","eu","dev",“beta" and "app".
 * For test.v-comply.com env, we will be using devapi.v-comply.com
 * For eu.v-comply.com env, we will be using euapi.v-comply.com
 */
export class S3urlResolverService {
  s3Url$: any

  constructor(private http: HttpClient, handler: HttpBackend, private route: ActivatedRoute) {
    this.http = new HttpClient(handler)
    this.s3Url$ = this.AWSMode(environment.s3BucketUrl).pipe(shareReplay(1))
  }
  AWSMode(url: any) {
    return of({
      bucket: '',
      s3_url: 'https://d35ffbrbs4js97.cloudfront.net',
    })
  }

  public load(): Promise<any> {
    return new Promise((resolve, reject) => {
      this.s3Url$.subscribe(
        (response: any) => {
          environment.s3Url = response.s3_url.toString()
          environment.s3Bucket = response.bucket.toString()
          this.setIntegration()
          resolve(true)
        },
        (error: any) => {
          this.setIntegration()
          console.error(error)
        },
      )
    })
  }

  setIntegration() {
    let params = new URLSearchParams(document.location.search)
    if (params.get('integration')) {
      localStorage.setItem(
        'integration',
        JSON.stringify({
          timestamp: Date.now(),
          type: params.get('integration') ?? '',
          exchangeId: params.get('exchangeId') ?? '',
          email: params.get('integration_email') ?? '',
          device_id: params.get(INTEGRATION_WORD_CONSTANTS.DEVICE_ID) ?? '',
        }),
      )
    }
  }
}
